module.exports = __webpack_public_path__ + "img/ZOHOCRM.c677e507.png";